import React from "react"
import PropTypes from "prop-types"

function Result({ image, title, text, extra }) {
  return (
    <div className="row w-100 justify-content-center p-3 text-center">
      <div className="col-md-6 col-lg-7">
        <img className="h-auto w-100 mb-2" src={image} alt="error" />
        <h2 className="result-title">{title}</h2>
        <p className="result-text">{text}</p>
        {extra}
      </div>
    </div>
  )
}
Result.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  extra: PropTypes.any,
}
export default Result
